import React from 'react'
import Modal from 'react-modal';
import { useState } from 'react';
import { updateEntry } from '../features/entries/entrySlice';
import { useDispatch } from 'react-redux';
import { deleteEntry } from '../features/entries/entrySlice'

const desktopStyles = {
  content: {
    width: '30%',
    height: '45%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const mobileStyles = {
  content: {
    width: '95%',
    height: '45%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

var style = function() {
  if (window.innerWidth <= 600) {
    return mobileStyles;
  } else {
    return desktopStyles;
  }
};

const closeButtonStyle = {
  marginBottom: '20px',
  marginTop: '0px',
  marginLeft: '0px'
}

// imported in EntryItem.jsx. This is a FUNCTIONAL COMPONENT
function EditModal({entry, closeModal, modalIsOpen}) {

  //let data = [entry.name, entry.alias, entry.medicalCond, entry.rfa];

  const dispatch = useDispatch()

  const onSubmit = (e) => {
    //e.preventDefault()
    console.log(e.target.value)

    // dispatch(updateEntry({id: entry._id, text: text}))           // STUFF TO FIX HERE
    
    // dispatch(updateEntry({id: entry._id, inmateData: inmateData}))
    // dispatch(updateEntry({id: entry._id, inmateData: e.target.value}))   NOPE
    dispatch(updateEntry({id: entry._id, name: name})) 
    dispatch(updateEntry({id: entry._id, alias: alias})) 
    dispatch(updateEntry({id: entry._id, medicalCond: medicalCond})) 
    dispatch(updateEntry({id: entry._id, rfa: rfa})) 

    // HAMZA'S
    // HTML: <input type="text" name='text' id='text' value={text} onChange={(e) => setText(e.target.value)}/>
  }

  const [name, setName] = useState(entry.name);
  const [alias, setAlias] = useState(entry.alias);
  const [medicalCond, setMedicalCond] = useState(entry.medicalCond);
  const [rfa, setRfa] = useState(entry.rfa);
    
  return (
    <><div>
    <Modal
      isOpen={modalIsOpen}
      ariaHideApp={false}
      //onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      //style={desktopStyles}
      style={style()}
      contentLabel="Example Modal"
    >
      <button onClick={closeModal} style={closeButtonStyle}>close</button>
      <h2>Edit Entry</h2>
      
      <form onSubmit={onSubmit}>
        <div className="form-group">
          {/* width:"100%" ensures the table takes up most of the Modal's width */}
          <table style={{width:"100%"}}>
            <tbody>
              <tr>
                <th scope="col">name</th>
                {/* <td>{entry.name}</td> */}
                <td><input type="text" name='name' id='name' value={name} onChange={(e) => setName(e.target.value)}/></td>
              </tr>
              <tr>
                <th scope="row">alias</th>
                {/* <td>{entry.alias}</td> */}
                <td><input type="text" name='alias' id='alias' value={alias} onChange={(e) => setAlias(e.target.value)}/></td>
              </tr>
              <tr>
                <th scope="row">medicalCond</th>
                <td>
                  <textarea 
                    rows="4" 
                    columns="30" 
                    name='medicalCond' 
                    id='medicalCond' 
                    value={medicalCond} 
                    onChange={(e) => setMedicalCond(e.target.value)}>
                  </textarea>
                </td>
              </tr>
              <tr>
                <th scope="row">rfa</th>
                <td>
                  {/* <input type="text" name='rfa' id='rfa' value={rfa} onChange={(e) => setRfa(e.target.value)}/></td> */}
                  <textarea 
                    rows="4" 
                    columns="30" 
                    name='rfa' 
                    id='rfa' 
                    value={rfa} 
                    onChange={(e) => setRfa(e.target.value)}>
                  </textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="form-group">
            <button className="btn btn-block" type='submit'>Apply</button>

            {/* NEW: delete button at bottom */}
            <button className="btn btn-block" onClick={() => dispatch(deleteEntry(entry._id))}>Delete</button>
        </div>
        </form>
    </Modal>
  </div></>
  )
}

export default EditModal